export default __webpack_public_path__ + "static/media/banner-top.51cb70e2.png";